// components/Loader.js
import React from "react";
import { Circles } from "react-loader-spinner"; // You can switch to another loader if you prefer

const Loader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#fff", 
      }}
    >
      <Circles
        height="80"
        width="80"
        color="rgb(212, 176, 165)" 
        ariaLabel="loading"
      />
    </div>
  );
};

export default Loader;
